import { createAsyncThunk } from '@reduxjs/toolkit';
import { Settings } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchSettings, FindSettings, GetSettings } from './interface';

export const findSettings = createAsyncThunk(
  'settings/findSettings',
  async (values: FindSettings, { rejectWithValue }) => {
    try {
      const response = await Settings.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createSettings = createAsyncThunk(
  'settings/createSettings',
  async (values: CreatePatchSettings, { rejectWithValue }) => {
    try {
      const response = await Settings.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchSettings = createAsyncThunk(
  'settings/patchSettings',
  async ({ id, ...values }: CreatePatchSettings, { rejectWithValue }) => {
    try {
      const response = await Settings.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getSettings = createAsyncThunk(
  'settings/getSettings',
  async ({ id }: GetSettings, { rejectWithValue }) => {
    try {
      const response = await Settings.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);